import 'react-mde/lib/styles/css/react-mde-all.css';
import * as Showdown from 'showdown';
import { makeStyles } from '@material-ui/core/styles';
import { useState } from 'react';
import Card from '@material-ui/core/Card';
import ReactMde from 'react-mde';

const converter = new Showdown.Converter({
	simplifiedAutoLink: true,
	strikethrough: true,
	tables: true,
	tasklists: true,
});

const toolbarCommands = [
	['header', 'bold', 'italic', 'strikethrough'],
	['link', 'quote', 'code'],
	['unordered-list', 'ordered-list', 'checked-list'],
];

const useStyles = makeStyles(() => ({
	markdown: {
		// '& .mde-header': {
		//     display:'none'
		// },
		'& .mde-preview': {
			minHeight: '31px !important',
		},

		'& .react-mde': {
			border: 'none',
		},

		minHeight: '77px !important',
		width: '100%',
	},
}));

interface Props {
	value?: string;
	onChange: (value: string) => void;
}

export function MarkdownField({ onChange, value }: Props) {
	const classes = useStyles();
	const [selectedTab, setSelectedTab] = useState<'write' | 'preview'>(
		'write',
	);

	return (
		<Card className={classes.markdown}>
			<ReactMde
				generateMarkdownPreview={async (markdown) =>
					await Promise.resolve(converter.makeHtml(markdown))
				}
				onChange={onChange}
				onTabChange={setSelectedTab}
				selectedTab={selectedTab}
				toolbarCommands={toolbarCommands}
				value={value}
			/>
		</Card>
	);
}
